import validate from "/builds/s-o-f/vkusilosos-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/builds/s-o-f/vkusilosos-frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-category-dish-route": () => import("/builds/s-o-f/vkusilosos-frontend/middleware/check-category-dish-route.ts"),
  "check-category-route": () => import("/builds/s-o-f/vkusilosos-frontend/middleware/check-category-route.ts")
}